import React, { useEffect } from "react"
import { withRouter, useParams } from "react-router-dom"
import { connect } from "react-redux"
import { Col, Table } from "reactstrap"
//Import Styles
import "./styles.scss"
import { isEmpty, get } from "lodash"
import clientAction from "../../store/Y2xpZW50/actions"
import { useSelector } from "react-redux"
import PropTypes from "prop-types"

const EcClientDetails = (props) => {
  const { dispatch,multiArrayLeadId,ecLoading } = props
  let { id } = useParams()
  useEffect(() => {
    if (ecLoading === true) {
    dispatch(clientAction.loadRecordClientDetails(multiArrayLeadId))
    dispatch(clientAction.loadRecords(multiArrayLeadId))
    } else {
      dispatch(clientAction.loadRecordClientDetails(id))
      dispatch(clientAction.loadRecords(id))
    }
  }, [ecLoading])

  //const specificDispatch = useDispatch()
  const clientUpdate = useSelector((specificState) => specificState.client)
  const {
    record_client_details = [],
    record_client_profile = {},
  } = clientUpdate
  const qcApproved =
    record_client_profile && record_client_profile.leadDetails
      ? record_client_profile.leadDetails[0].processStatus
      : []
  //Client Data Table
  const clientData = get(record_client_details[0], "clientDetails", "")

  var slNovalue = 0
  const clientDataTable = !isEmpty(clientData)
    ? clientData.map((client, index) => {
        //Bride details
        const statusUpdate = get(client, "status", "no status")
        const profileId = get(client, "_id", "no id")
        const brideName = get(client.bride, "brideName", "No Name")
        const brideMobile = get(client.bride, "brideMobileNo", "No mobile")
        const brideWhatsapp = get(
          client.bride,
          "brideWhatsappNo",
          "No WhatsApp"
        )
        const brideEmail = get(client.bride, "brideEmailId", "No Email")
        const brideProfiles = get(client.bride, "brideProfile", "No Profile")
        const brideProfileRemarks = get(
          client.bride,
          "brideProfileRemark",
          "No Profile"
        )

        // Groom details
        const groomName = get(client.groom, "groomName", "No Name")
        const groomMobile = get(client.groom, "groomMobileNo", "No mobile")
        const groomWhatsapp = get(
          client.groom,
          "groomWhatsappNo",
          "No WhatsApp"
        )
        const groomEmail = get(client.groom, "groomEmailId", "No Email")
        const groomProfiles = get(client.groom, "groomProfile", "No Profile")
        const groomProfileRemarks = get(
          client.groom,
          "groomProfileRemark",
          "No Profile"
        )

        if (statusUpdate == 1) {
          slNovalue = slNovalue + 1
          return {
            _id: profileId,
            status: statusUpdate,
            sNo: slNovalue,
            brideName: brideName,
            brideMobileNo: brideMobile,
            brideWhatsappNo: brideWhatsapp,
            brideEmailId: brideEmail,
            brideProfile: brideProfiles,
            brideRemarks: brideProfileRemarks,
            groomName: groomName,
            groomMobileNo: groomMobile,
            groomWhatsappNo: groomWhatsapp,
            groomEmailId: groomEmail,
            groomProfile: groomProfiles,
            groomRemarks: groomProfileRemarks,
            key: index,
          }
        } else {
          return { _id: "" }
        }
      })
    : []

  console.log(qcApproved, "qcApproved")
  return (
    <React.Fragment>
      <Col
        style={{
          display: "flex",
          alignItems: "center",
          paddingTop: "20px",
          paddingBottom: "15px",
        }}
      >
        <p
          style={{
            color: "#4486eb",
            margin: "0px",
            marginRight: "15px",
            fontSize: "16px",
            fontWeight: "500",
          }}
        >
          Client Details
        </p>
      </Col>
      <Col md="12" lg="12" xl="12">
        <Table
          bordered
          striped
          responsive
          // className="w-100"
        >
          <thead>
            <tr style={{ fontSize: "10px" }}>
              <th>S.No</th>
              {/* <th>Actions</th> */}
              <th style={{ minWidth: "140px" }}>Bride Name</th>
              <th style={{ minWidth: "130px" }}>Mobile No</th>
              <th>WhatsApp</th>
              <th style={{ minWidth: "130px" }}>Email Id</th>
              <th style={{ minWidth: "140px" }}>Bride Profile</th>
              <th style={{ minWidth: "140px" }}>Groom Name</th>
              <th style={{ minWidth: "130px" }}>Mobile No</th>
              <th>WhatsApp</th>
              <th style={{ minWidth: "140px" }}>Email Id</th>
              <th style={{ minWidth: "140px" }}>groom Profile</th>
            </tr>
          </thead>
          <tbody>
            {clientDataTable &&
              clientDataTable.map((client) => {
                if (client._id) {
                  return (
                    <tr key={client.id}>
                      <td>{client.sNo}</td>
                      <td
                        className="table-client-row"
                        style={{
                          textTransform: "uppercase",
                        }}
                      >
                        {client.brideName}
                      </td>
                      <td>{client.brideMobileNo}</td>
                      <td>{client.brideWhatsappNo}</td>
                      <td>{client.brideEmailId}</td>
                      <td
                        style={{
                          textTransform: "uppercase",
                        }}
                      >
                        {client.brideProfile}
                      </td>
                      <td
                        style={{
                          textTransform: "uppercase",
                        }}
                      >
                        {client.groomName}
                      </td>
                      <td>{client.groomMobileNo}</td>
                      <td>{client.groomWhatsappNo}</td>
                      <td>{client.groomEmailId}</td>
                      <td
                        style={{
                          textTransform: "uppercase",
                        }}
                      >
                        {client.groomProfile}
                      </td>
                    </tr>
                  )
                }
              })}
          </tbody>
        </Table>
      </Col>
    </React.Fragment>
  )
}
EcClientDetails.propTypes = {
  dispatch: PropTypes.func,
  record_client_details: PropTypes.array,
  record_profile: PropTypes.array,
  recordsMetaData: PropTypes.object,
  location: PropTypes.array,
  error: PropTypes.any,
  multiArrayLeadId: PropTypes.any,
  ecLoading: PropTypes.any,
  access: PropTypes.array,
  metaData: PropTypes.object,
  loading: PropTypes.any,
  success: PropTypes.any,
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

const mapStateToProps = () => ({
  //mapstate to props
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EcClientDetails)
)
